import { Routes, Route } from 'react-router-dom';

import { ClientScreen } from '../pages/clientScreen/ClientScreen';
import { AddClient } from '../pages/clientScreen/AddClient';
import { ProfileEditScreen } from '../pages/profileEdition/ProfileEditScreen';
import { EstimateScreen } from '../pages/estimate/EstimateScreen';
import { AddEstimate } from '../pages/estimate/AddEstimate';
import { UserScreen } from '../pages/configuration/UserScreen';
import { EditClient } from '../pages/clientScreen/EditClient';
import { Welcome } from '../pages/welcomeScreen/Welcome';
import { useContext } from 'react';
import { AuthContext } from '../auth/authContext';
import { AddProducts } from '../pages/products/components/AddProducts';
import { PrintPDF } from '../pages/bill/PrintPDF';
import { DetailEstimate } from '../pages/estimate/DetailEstimate';
import { FetchEditEstimate } from '../pages/estimate/FetchEditEstimate';
import { AddCertification } from '../pages/certification/AddCertification';
import { FetchCertificationScreen } from '../pages/certification/components/FetchCertificationScreen';
import { EditCertification } from '../pages/certification/EditCertification';
import { GetProduct } from '../pages/products/components/GetProduct';
import { EditProducts } from '../pages/products/components/EditProducts';
import { CreateUserScreen } from '../pages/configuration/CreateUserScreen';
import { EditUser } from '../pages/configuration/EditUser';
import { WorkScreen } from '../pages/work/WorkScreen';
import { EditWork } from '../pages/work/components/EditWork';
import { NextCall } from '../pages/estimate/NextCall';
import { WorkViewData } from '../pages/work/WorkViewData';
import { EstimateViewData } from '../pages/estimate/EstimateViewData';
import { CertificationViewData } from '../pages/certification/CertificationViewData';

export const BodyDashRouters = () => {

  const { user } = useContext(AuthContext);

  return (

    <Routes>
      <Route path='/profile' element={<ProfileEditScreen />}></Route>

      <Route path='/client' element={<ClientScreen />}></Route>
      <Route path='/addClient' element={<AddClient />}></Route>
      <Route path='/editClient' element={<EditClient />}></Route>

      <Route path='/estimate' element={<EstimateScreen />}></Route>
      <Route path='/estimateTemporary' element={<EstimateScreen status='Provisional' />}></Route>
      <Route path='/estimateAccepted' element={<EstimateScreen status='Aceptado' />}></Route>
      <Route path='/estimateDefinitive' element={<EstimateScreen status='Definitivo' />}></Route>
      <Route path='/addEstimate' element={<AddEstimate />}></Route>
      <Route path='/detailEstimate' element={<DetailEstimate />}></Route>
      <Route path='/editEstimate' element={<FetchEditEstimate />}></Route>
      <Route path='/nextCall' element={<NextCall />}></Route>
      <Route path='/viewEstimate' element={<EstimateViewData />}></Route>

      <Route path='/certification' element={<FetchCertificationScreen />}></Route>
      <Route path='/addCertification' element={<AddCertification />}></Route>
      <Route path='/editCertification' element={<EditCertification />}></Route>
      <Route path='/viewCertification' element={<CertificationViewData />}></Route>

      <Route path='/works' element={<WorkScreen />}></Route>
      <Route path='/pendingAssembly' element={<WorkScreen status={'Pendiente de montaje'} />}></Route>
      <Route path='/assembly' element={<WorkScreen status={'Montada'} />}></Route>
      <Route path='/pendingDisassembly' element={<WorkScreen status={'Pendiente de desmontaje'} />}></Route>
      <Route path='/pendingCollection' element={<WorkScreen status={'Pendiente de recogida'} />}></Route>
      <Route path='/finished' element={<WorkScreen status={'Terminada'} />}></Route>
      <Route path='/notCertificate' element={<WorkScreen isItCertified={true} />}></Route>
      <Route path='/editWork' element={<EditWork/>}></Route>
      <Route path='/viewWork' element={<WorkViewData/>}></Route>

      <Route path='/product' element={<GetProduct />}></Route>
      <Route path='/addProducts' element={<AddProducts />}></Route>
      <Route path='/editProducts' element={<EditProducts />}></Route>
      <Route path='/service' element={<GetProduct type='Servicio'/>}></Route>
      <Route path='/rent' element={<GetProduct type='Alquiler'/>}></Route>

      <Route path='/configuration' element={user.rol === 'Administrador' ? <UserScreen /> : <Welcome />}></Route>
      <Route path='/addUser' element={user.rol === 'Administrador' ? <CreateUserScreen /> : <Welcome />}></Route>
      <Route path='editUser' element={user.rol === 'Administrador' ? <EditUser /> : <Welcome />}></Route>

      <Route path='/print' element={<PrintPDF />}></Route>

      <Route path='/' element={<Welcome />}></Route>
    </Routes>
  )
}


